import { getUserWorkingHoursPart } from '@vacationtracker/shared/graphql/shared-queries'

export const getCompanyAllUsers = /* GraphQL */ `
  query GetCompanyAllUsers {
    getAllUserListPaginated(limit: 1000) {
      users {
        id
        name
        status
        imageUrl
        locationId
      }
      nextToken
    }
    getLocationList {
      id
      name
      holidays {
        year
        holidays {
          name
          date
          isHalfDay
        }
      }
    }
  }
`

export const getUserDashboardData = /* GraphQL */ `
  query GetUserDashboard($userId: String!, $date: String!, $pendingLeavesDate: String!, $dateStart: String!, $dateEnd: String!) {
    getCompany {
      id
      name
      hourlyLeaveAccounting
    }
    getUser(id: $userId) {
      id
      name
      email
      role
      isAdmin
      imageUrl
      startDate
      endDate
      employeeId
      platform
      status
      workHours {${getUserWorkingHoursPart()}}
      timestamp
      locale
      hourFormat
      location {
        id
        name
        timezone
        holidays {
          year
          holidays {
            name
            date
            isHalfDay
          }
        }
        workHours
        firstDayOfWeek
        resetQuotas
        rolloverNeverExpireDays
        rolloverExpiryMonth
        rolloverExpiryDay
        rolloverExpiryAfterDays
        yearStartDay
        yearStartMonth
        leavePolicies {
          id
          name
          allowHalfDays
          accrualPeriodStart
          shortestLeaveInterval
          isActive
          isReasonRequired
          maxRolloverDays
        }
      }
      team {
        id
        name
        approvers {
          id
          name
          imageUrl
        }
        users {
          id
          name
          status
          imageUrl
          locationId
        }
      }
      leaveDays {
        yearStart
        yearEnd
        leaveTypes {
          leaveTypeId
          leaveTypeName
          leavePolicyId
          color
          position
          isActive
          hasUnlimitedDays
          currentDays
          usedDays
          scheduledDays
          quota
          baseQuota
          rolloverFromPreviousYear
          rolloverExpiryDate
          accrualType
          accrualPeriodStart
          capHit
          firstEarningDate
          defaultDaysPerYear
          earnedDays
          expiredDays
          userLeaveTypeOverride
          allowHalfDays
          shortestLeaveInterval
          toilDays
          toilDaysLapsed
          quotas {
            remaining {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            used {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            scheduled {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            baseQuota {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            quotaAtYearEnd {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            earnedWithoutRollover {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            rolloverFromPreviousYear {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            expired {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
            pending {
              raw {
                days
                hours
              }
              days
              hours
              minutes
              isNegative
            }
          }
        }
      }
      upcomingLeaves(date: $date) {
        id
        startDate
        endDate
        status
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        workingDays
        reason
        statusReason
        leaveType {
          id
          name
          color
        }
        approver {
          id
          name
        }
        autoApproved
      }
      today(date: $date) {
        id
        startDate
        endDate
        status
        isPartDay
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        workingDays
        reason
        statusReason
        leaveType {
          id
          name
          color
        }
        approver {
          id
          name
        }
        autoApproved
      }
      pendingLeaves(date: $pendingLeavesDate) {
        id
        startDate
        endDate
        status
        isPartDay
        workingDays
        leaveType {
          id
          name
          color
        }
        partDayStartHour
        partDayEndHour
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        reason
      }
      history(date: $date) {
        id
        status
        startDate
        endDate
        workingDays
        leaveType {
          id
          name
          color
        }
      }
      probationPeriod {
        lengthDays
        name
        leaveTypeIds
      }
    }
    getVisibilityAddon {
      visibilityLevel
    }
    getLocationList {
      id
      name
      holidays {
        year
        holidays {
          name
          date
          isHalfDay
        }
      }
    }
    getTeamLeaves: getLeaveRequestByDate(
      dateStart: $dateStart,
      dateEnd: $dateEnd,
      status: "APPROVED",
      limit: 100,
      nextToken: "NONE"
    ) {
      leaveRequests {
        id
        user {
          id
          name
          imageUrl
        }
        leaveType {
          name
          color
        }
        startDate
        endDate
        isPartDay
        partDay {
          startHour
          startMinute
          endHour
          endMinute
        }
        workingDays
      }
    }
  }
`
